export default __webpack_public_path__ + "static/media/kioskUpiIcon.7985127d.svg";